import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVertRounded';
import { Icon } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import KeyIcon from '@mui/icons-material/Key';
import ExpoRichiesteService from "services/API/ExpoRichieste/ExpoRichiesteService";
import download_pdf_allegato from 'common/script/download_pdf_allegato';
import genera_contratto from 'common/script/genera_contratto';
import vedi_anteprima_contratto from 'common/script/vedi_anteprima_contratto';
import { useFarFieraUIController } from 'common/context/FarFieraContext';

const ITEM_HEIGHT = 48;

const ExpoRichiesteMenu = ({ proposta,filtra }) => {

  const navigate = useNavigate();
  const [ffcontroller] = useFarFieraUIController();
  const { manifestazione } = ffcontroller;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMessaggi = () => {
    navigate("/expo_richiestaMessage", { state: { id_proposta: proposta.idRichiesta, chiamante: 'expo_richieste_ok_admin' } });

  };
  const handleVisualizzaPdf = () => {
    navigate("/expo_richiestaPDFVis", { state: { modo: 'vis', soggetto: proposta.idRichiesta, chiamante: "expo_richieste_ok_admin" } });
  };

  const handleVisualizzaEsito = () => {

    if (proposta.id_allegato_esito != null && proposta.nome_file_esito) {

      download_pdf_allegato(proposta.id_allegato_esito, proposta.nome_file_esito);
    }

  }

  function handleEnableAR() {
    if (proposta.id_partecipazione == null || proposta.id_partecipazione == 0) {
      ExpoRichiesteService.abilita_area_riservata_1(proposta.idRichiesta)
        .then(response => {

          alert("Area Riservata Abilitata correttamente");
          filtra(manifestazione);

        })
        .catch(e => {
          console.log(e);
          alert("Errore:" + e.response.data);
          filtra(manifestazione);
           setAnchorEl(null);
        });
    } else {
      alert("Area Riservata Già abilitata");
    }

  }




  function handleVisualizzaAnteprimaContratto() {

    if (proposta.id_partecipazione != null && proposta.id_partecipazione != 0) {
      genera_contratto(proposta.id_partecipazione);


    } else {
      vedi_anteprima_contratto(proposta.idRichiesta);
    }

  }



  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: '25ch',
            },
          },
          list: {
            'aria-labelledby': 'long-button',
          },
        }}
      >

        <MenuItem disableRipple onClick={handleMessaggi}>

          < AttachEmailIcon />
          &nbsp;&nbsp;Messaggi Inviati
        </MenuItem>
        <MenuItem disableRipple onClick={handleVisualizzaPdf}>
          <Icon>visibility</Icon>
          &nbsp;&nbsp;PDF Proposta
        </MenuItem>
        <MenuItem disableRipple onClick={handleEnableAR}>
          <KeyIcon />
          &nbsp;&nbsp;Abilita A.R.
        </MenuItem>
        <MenuItem disableRipple onClick={handleVisualizzaEsito}>
          <Icon>visibility</Icon>
          &nbsp;&nbsp;PDF Esito
        </MenuItem>
        <MenuItem disableRipple onClick={handleVisualizzaAnteprimaContratto}>
          <Icon>visibility</Icon>
          &nbsp;&nbsp;Anteprima Contratto
        </MenuItem>
      </Menu>
    </div>
  );
}


export default ExpoRichiesteMenu;